import http from './http'

export function generatePairingCode() {
  return http.post('/nodes/pairing-code')
}

export function generatePairingToken() {
  return http.post('/nodes/pairing-token')
}

export function listNodes() {
  return http.get('/nodes')
}

export function getNode(id) {
  return http.get(`/nodes/${id}`)
}

export function updateNode(id, payload) {
  return http.put(`/nodes/${id}`, payload)
}

export function deleteNode(id) {
  return http.delete(`/nodes/${id}`)
}

export function resetNode(id) {
  return http.post(`/nodes/${id}/reset`)
}

export function sendCommand(payload) {
  return http.post('/mission/command', payload)
}

export function getIceServers() {
  return http.get('/webrtc/ice-servers')
}

export function listMessages() {
  return http.get('/mission/messages')
}

export function createMessage(payload) {
  return http.post('/mission/messages', payload)
}

export function sendAlert(payload) {
  return http.post('/mission/alert', payload)
}

export function listEvents(nodeId) {
  const params = nodeId ? { node_id: nodeId } : {}
  return http.get('/mission/events', { params })
}

export function listWorkspaces() {
  return http.get('/workspace')
}

export function createWorkspace(name) {
  return http.post('/workspace', { name })
}

export function getWorkspace(id) {
  return http.get(`/workspace/${id}`)
}

export function saveWorkspace(id, payload) {
  return http.put(`/workspace/${id}`, payload)
}

export function deleteWorkspace(id) {
  return http.delete(`/workspace/${id}`)
}

export function resetWorkspace(id) {
  return http.post(`/workspace/${id}/reset`)
}

export function getLayout() {
  return http.get('/workspace/layout')
}

export function saveLayout(payload) {
  return http.put('/workspace/layout', payload)
}

export function resetLayout() {
  return http.post('/workspace/layout/reset')
}

export function getWidgetCatalog() {
  return http.get('/workspace/widgets')
}

export function getDashboardWSUrl() {
  const configured = process.env.VUE_APP_PUBLIC_API_URL
  if (configured) {
    const wsBase = configured.replace(/^https:/, 'wss:').replace(/^http:/, 'ws:')
    return `${wsBase}/ws/dashboard`
  }
  if (typeof window !== 'undefined' && window.location?.host) {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${proto}//${window.location.host}/ws/dashboard`
  }
  return 'ws://localhost:9000/ws/dashboard'
}
